import script from "./YingBiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./YingBiPage.vue?vue&type=script&setup=true&lang=js"

import "./YingBiPage.vue?vue&type=style&index=0&id=07fc7b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07fc7b06"]])

export default __exports__